import ThermometerSalesGoal from './ThermometerSalesGoal';
export default ThermometerSalesGoal;